import React, { useState, useEffect } from 'react';
import { Calendar, Check, Send, Loader2, Sparkles, Brain, Edit3, Target, X, Save, BookOpen } from 'lucide-react';
import { db } from '../firebase';
import {
  SMART_PLAN_STRATEGIES
} from '../utils/coaching/smartPlanStrategies';

const mufredatVerisi = {
  "TYT - Türkçe": ["Sözcükte Anlam", "Cümlede Anlam", "Paragrafta Anlam", "Ses Bilgisi", "Yazım Kuralları", "Noktalama İşaretleri", "Sözcükte Yapı", "Sözcük Türleri", "Cümlenin Öğeleri", "Cümle Türleri", "Anlatım Bozuklukları"],
  "TYT - Matematik": ["Sayılar", "Bölme/Bölünebilme", "Rasyonel Sayılar", "Basit Eşitsizlikler", "Mutlak Değer", "Üslü Sayılar", "Köklü Sayılar", "Çarpanlara Ayırma", "Oran Orantı", "Problemler", "Kümeler", "Fonksiyonlar", "Olasılık", "Polinomlar"],
  "TYT - Geometri": ["Doğruda ve Üçgende Açılar", "Benzerlik", "Çokgenler ve Dörtgenler", "Çember ve Daire", "Analitik Geometri", "Katı Cisimler"],
  "TYT - Fizik": ["Fizik Bilimi", "Madde ve Özellikleri", "Kaldırma Kuvveti", "Basınç", "Isı ve Sıcaklık", "Hareket", "Dinamik", "İş ve Enerji", "Elektrik", "Optik"],
  "TYT - Kimya": ["Kimya Bilimi", "Atom", "Periyodik Sistem", "Etkileşimler", "Maddenin Halleri", "Asit, Baz, Tuz", "Karışımlar"],
  "TYT - Biyoloji": ["Canlıların Bileşenleri", "Hücre", "Sınıflandırma", "Mitoz/Mayoz", "Kalıtım", "Ekoloji"],
  "TYT - Tarih": ["Tarih Bilimi", "İlk Türk Devletleri", "İslam Tarihi", "Osmanlı Devleti", "İnkılap Tarihi"],
  "TYT - Coğrafya": ["Doğa ve İnsan", "Dünya'nın Şekli", "Harita Bilgisi", "İklim", "Nüfus", "Ekonomik Faaliyetler", "Doğal Afetler"],
  "TYT - Felsefe": ["Felsefeyi Tanıma", "Bilgi", "Varlık", "Ahlak", "Siyaset", "Din Felsefesi"],
  "TYT - Din Kültürü": ["İnanç", "İbadet", "Hz. Muhammed'in Hayatı", "Vahiy ve Akıl"],
  
  "AYT - Matematik": ["Mantık", "Eşitsizlikler", "Parabol", "Trigonometri", "Logaritma", "Diziler", "Limit", "Türev", "İntegral"],
  "AYT - Geometri": ["Çemberin Analitiği", "Dönüşümler", "Trigonometri", "Uzay Geometri"],
  "AYT - Edebiyat": ["Şiir Bilgisi", "İslamiyet Öncesi", "Divan Edebiyatı", "Halk Edebiyatı", "Tanzimat", "Servetifünun", "Milli Edebiyat", "Cumhuriyet Edebiyatı"],
  "AYT - Fizik": ["Vektörler", "Tork", "Atışlar", "Momentum", "Çembersel Hareket", "Basit Harmonik", "Dalga Mekaniği", "Modern Fizik"],
  "AYT - Kimya": ["Modern Atom", "Gazlar", "Sıvı Çözeltiler", "Kimya ve Enerji", "Tepkime Hızı", "Kimyasal Denge", "Elektrokimya", "Organik Kimya"],
  "AYT - Biyoloji": ["Sinir Sistemi", "Endokrin", "Duyu Organları", "Destek ve Hareket", "Sindirim", "Dolaşım", "Solunum", "Üreme", "Bitki Biyolojisi", "Canlılık ve Enerji"],
 "AYT - Tarih": ["İlk Çağ", "İlk Türk Devletleri", "Orta Çağ'da Avrupa", "Osmanlı Tarihi", "İnkılap Tarihi", "Çağdaş Türk ve Dünya Tarihi"],
  "AYT - Coğrafya": ["Biyoçeşitlilik", "Şehirler ve Ekonomi", "Türkiye'de Tarım ve Hayvancılık", "Küresel Ortam", "Çevre ve İnsan"],

  // --- 🚀 YENİ: LGS MÜFREDATI ---
  "LGS - Türkçe": ["Fiilimsiler", "Cümlenin Ögeleri", "Cümle Türleri", "Sözcükte Anlam", "Cümlede Anlam ve Yorumlama", "Paragrafta Anlam ve Yapı", "Tablo, Grafik ve Görsel Yorumlama", "Sözel Mantık (Akıl Yürütme)", "Metin Türleri", "Söz Sanatları", "Yazım Kuralları", "Noktalama İşaretleri", "Fiillerde Çatı", "Anlatım Bozuklukları"],
  "LGS - Matematik": ["Çarpanlar ve Katlar", "Üslü İfadeler", "Kareköklü İfadeler", "Veri Analizi", "Basit Olayların Olma Olasılığı", "Cebirsel İfadeler ve Özdeşlikler", "Doğrusal Denklemler", "Eşitsizlikler", "Üçgenler", "Eşlik ve Benzerlik", "Geometrik Cisimler", "Dönüşüm Geometrisi"],
  "LGS - Fen Bilimleri": ["Mevsimler ve İklimler", "DNA ve Genetik Kod", "Basınç", "Madde ve Endüstri", "Periyodik Sistem", "Fiziksel ve Kimyasal Değişimler", "Asitler ve Bazlar", "Basit Makineler", "Canlılar ve Enerji İlişkileri", "Enerji Dönüşümleri ve Çevre Bilimi", "Elektrik Yükleri ve Elektrik Enerjisi"],
  "LGS - İnkılap Tarihi": ["Bir Kahraman Doğuyor", "Milli Uyanış: Bağımsızlık Yolunda", "Milli Bir Destan; Ya İstiklal Ya Ölüm", "Çağdaş Türkiye Yolunda Adımlar", "Demokratikleşme Çabaları", "Atatürkçülük", "Türk Dış Politikası ve Atatürk’ün Ölümü", "İkinci Dünya Savaşı Ve Sonrası"],
  "LGS - İngilizce": ["Friendship", "Teen Life", "In the Kitchen", "On the Phone", "The Internet", "Adventures", "Tourism", "Chores", "Science", "Natural Forces"],
  "LGS - Din Kültürü": ["Kader ve Kaza İnancı", "Zekât ve Sadaka İbadeti", "Din, Birey ve Toplum", "Hz. Muhammed ve Örnekliği", "Kur’an-ı Kerim ve Özellikleri"]
};


const SMART_TASK_LABELS = {
  new_topic: 'Yeni Konu',
  practice: 'Soru Çözümü',
  review: 'Tekrar',
  mixed_practice: 'Karma Soru',
  branch_mock: 'Branş Denemesi',
  full_mock: 'Tam Deneme',
  mock_analysis: 'Deneme Analizi',
  buffer: 'Telafi / Esnek Alan',
  routine: 'Rutin'
};


const SMART_TASK_DESCRIPTIONS = {
  buffer:
    'Eksik kalan görevi tamamla, yanlış sorularını gözden geçir veya kısa tekrar yap.',

  routine:
    'Daha önce çalıştığın konuyu canlı tutmak için kısa ve düzenli pekiştirme çalışması.'
};

const StudentPlanner = ({ user, onSubmit }) => { 
  const [activeTab, setActiveTab] = useState('plan'); 
  const [sinavTuru, setSinavTuru] = useState('TYT'); // 🚀 YENİ: Öğrencinin seçtiği sınav türü hafızası

  const [weekData, setWeekData] = useState({ Pazartesi: [], Salı: [], Çarşamba: [], Perşembe: [], Cuma: [], Cumartesi: [], Pazar: [] }); 
  const [loading, setLoading] = useState(false); 
  const [hasChanges, setHasChanges] = useState(false); 
  const [macroPlan, setMacroPlan] =
  useState(null);

const [interactiveMacro, setInteractiveMacro] =
  useState([]);

const [currentWeekIndex, setCurrentWeekIndex] =
  useState(0);


const [smartPlan, setSmartPlan] =
  useState(null);

const [
  interactiveSmartSchedule,
  setInteractiveSmartSchedule
] = useState([]);

const [
  smartHasChanges,
  setSmartHasChanges
] = useState(false);

const [smartWeekIndex, setSmartWeekIndex] =
  useState(0);

  // --- 🚀 YENİ: GÜNLÜK SORU GİRİŞİ HAFIZASI ---
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ ders: '', konu: '', toplam: '', dogru: '', yanlis: '', bos: '', sure: '' });
  
  // --- 🚀 YENİ: DENEME SONUCU HAFIZASI ---
  const [denemeStep, setDenemeStep] = useState(1);
  const [denemeData, setDenemeData] = useState({ 
    denemeTuru: '', denemeAdi: '', 
    turkceD: '', turkceY: '', sosyalD: '', sosyalY: '', 
    matematikD: '', matematikY: '', fenD: '', fenY: '',
    edebiyatD: '', edebiyatY: '', tarih1D: '', tarih1Y: '',
    cografya1D: '', cografya1Y: '', tarih2D: '', tarih2Y: '',
    cografya2D: '', cografya2Y: '', felsefeD: '', felsefeY: '',
    dinD: '', dinY: '', dilD: '', dilY: '',
    // 🚀 LGS Verileri
    lgsTurkceD: '', lgsTurkceY: '', lgsMatD: '', lgsMatY: '', lgsFenD: '', lgsFenY: '',
    lgsInkilapD: '', lgsInkilapY: '', lgsIngD: '', lgsIngY: '', lgsDinD: '', lgsDinY: ''
  });

  // --- KAYIT MOTORLARI ---
  const handleSubjectSelect = (ders) => {
    setFormData({ ...formData, ders });
    setStep(2); 
  };

  const handleSaveSoru = async () => {
    if (!formData.ders || !formData.toplam) {
      alert("Lütfen en azından bir Ders ve Çözülen Soru Sayısı (Toplam) giriniz!");
      return;
    }
    try {
      const safeCode = user.clinicianCode || user.refCode || user.code || "7335";
      const safeUid = user.clinicianUid || user.uid || "";
      const safeClass = user.class || user.studentClass || "Sınıfsız";
      const safeNo = user.no || user.studentNo || "0";
      const safeName = user.fullName || user.name || safeNo;

      await onSubmit({
        id: Date.now(),
        createdAt: Date.now(), 
        studentClass: safeClass,
        studentNo: safeNo,
        studentName: safeName,
        clinicianCode: safeCode,
        clinicianUid: safeUid, 
        testId: 'gunluk_soru_takibi', 
        testName: 'Günlük Soru / Net Takibi',
        answers: { ...formData, tarih: new Date().toLocaleDateString('tr-TR') },
        status: 'reported' 
      });

      alert("🚀 Harika! Bugünkü soru hedefin başarıyla kaydedildi.");
      setStep(1);
      setFormData({ ders: '', konu: '', toplam: '', dogru: '', yanlis: '', bos: '', sure: '' });
    } catch (error) {
      console.error("Kayıt Hatası:", error);
      alert("⚠️ Veri gönderilirken bir hata oluştu.");
    }
  };

  const handleDenemeSelect = (turu) => {
    setDenemeData({ ...denemeData, denemeTuru: turu });
    setDenemeStep(2); 
  };

  const handleDenemeSave = async () => {
    if (!denemeData.denemeTuru || !denemeData.denemeAdi) {
      alert("Lütfen deneme adını ve türünü boş bırakmayınız.");
      return;
    }
    try {
      const safeCode = user.clinicianCode || user.refCode || user.code || "7335";
      const safeUid = user.clinicianUid || user.uid || "";
      const safeClass = user.class || user.studentClass || "Sınıfsız";
      const safeNo = user.no || user.studentNo || "0";
      const safeName = user.fullName || user.name || safeNo;

      await onSubmit({
        id: Date.now(),
        createdAt: Date.now(), 
        studentClass: safeClass,
        studentNo: safeNo,
        studentName: safeName,
        clinicianCode: safeCode,
        clinicianUid: safeUid, 
        testId: 'deneme_net_takibi', 
        testName: `${denemeData.denemeTuru} Deneme Analizi`,
        answers: { ...denemeData, tarih: new Date().toLocaleDateString('tr-TR') },
        status: 'reported' 
      });

      alert(`🎯 Süper! ${denemeData.denemeTuru} deneme netlerin başarıyla sisteme işlendi.`);
      setDenemeStep(1);
      setDenemeData({ denemeTuru: '', denemeAdi: '', turkceD: '', turkceY: '', sosyalD: '', sosyalY: '', matematikD: '', matematikY: '', fenD: '', fenY: '', edebiyatD: '', edebiyatY: '', tarih1D: '', tarih1Y: '', cografya1D: '', cografya1Y: '', tarih2D: '', tarih2Y: '', cografya2D: '', cografya2Y: '', felsefeD: '', felsefeY: '', dinD: '', dinY: '', dilD: '', dilY: '', lgsTurkceD: '', lgsTurkceY: '', lgsMatD: '', lgsMatY: '', lgsFenD: '', lgsFenY: '', lgsInkilapD: '', lgsInkilapY: '', lgsIngD: '', lgsIngY: '', lgsDinD: '', lgsDinY: '' });
    } catch (error) {
      console.error("Deneme Kayıt Hatası:", error);
      alert("⚠️ Veri gönderilirken bir hata oluştu.");
    }
  };

  useEffect(() => {
    const loadPlan = async () => { 
        try {
            // 🚀 YENİ: Veritabanına doğrudan gitmek yerine, Firebase'den yeni aldığın GÜVENLİ SANTRALE (Cloud Function) istek atıyoruz
            // DİKKAT: Aşağıdaki fetch adresini terminalin sana verdiği "getStudentPlans" adresiyle değiştirmeyi unutma!
            const response = await fetch("https://us-central1-rehber360-e0808.cloudfunctions.net/getStudentPlans", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    studentNo: user.no,
                    clinicianCode: user.clinicianCode,
                    clinicianUid: user.clinicianUid
                })
            });

            if (!response.ok) {
                throw new Error("Güvenli santrale ulaşılamadı.");
            }

            const data = await response.json();

            // 1. Haftalık Planı Ekrana Bas
            if (data.weeklyPlan) {
                setWeekData(data.weeklyPlan);
            }

            // 2. Makro Planı Ekrana Bas
            if (data.macroPlan) {
                setMacroPlan(data.macroPlan);
            }


            // 3. Akıllı Planı Ekrana Bas
if (data.smartPlan) {

    setInteractiveSmartSchedule(
      []
    );

    setSmartHasChanges(
      false
    );

    setSmartPlan(
      data.smartPlan
    );

    setSmartWeekIndex(0);

} else {

    setInteractiveSmartSchedule(
      []
    );

    setSmartHasChanges(
      false
    );

    setSmartPlan(null);
}
            

        } catch (error) {
            console.error("Plan yüklenirken hata oluştu:", error);
        }
    }; 
    
    // Sadece öğrenci bilgileri tamamsa santrali ara
    if (user.no) {
        loadPlan(); 
    }
  }, [user.no, user.clinicianCode, user.clinicianUid]);
  const toggleTask = (day, taskId) => { 
    const updatedTasks = weekData[day].map(task => task.id === taskId ? { ...task, completed: !task.completed } : task); 
    const newWeekData = { ...weekData, [day]: updatedTasks }; 
    setWeekData(newWeekData); setHasChanges(true); 
  }; 
  
 const handleManualSubmit = async () => { 
    setLoading(true); 
    try {
        // 🛡️ GÜVENLİK ZIRHI: Dashboard'daki aynı koruma mantığını buraya da kuruyoruz
        const safeCode = user.clinicianCode || user.refCode || user.code || "7335";
        const safeUid = user.clinicianUid || user.uid || "";
        const safeClass = user.class || user.studentClass || "Sınıfsız";
        const safeNo = user.no || user.studentNo || "0";
        const safeName = user.fullName || user.name || safeNo;

        // 1. MOTOR: Eğer üstte manuel (özel) görevler varsa onları öğretmene gönder
        if (totalTasks > 0) {
            await onSubmit({ 
                id: Date.now(), 
                createdAt: Date.now(), // 🚀 KRİTİK: Santralin en güncel planı bulması için şart!
                studentClass: safeClass, 
                studentNo: safeNo, 
                studentName: safeName,
                clinicianCode: safeCode,
                clinicianUid: safeUid, // 🚀 KRİTİK: Hata mesajını ortadan kaldıran anahtar!
                testId: 'weekly_plan', 
                testName: 'Özel Görevler', 
                answers: weekData, 
                status: 'pending' 
            }); 
        }

        // 2. MOTOR: Eğer altta Makro Kamp Planı varsa, atılan son tikleri öğretmene gönder
        if (interactiveMacro && interactiveMacro.length > 0) {
            await onSubmit({
                id: Date.now() + 1,
                createdAt: Date.now(), // 🚀 KRİTİK: Kaydedilen tiklerin uçmaması için tarih damgası!
                studentClass: safeClass,
                studentNo: safeNo,
                studentName: safeName,
                clinicianCode: safeCode,
                clinicianUid: safeUid, 
                testId: 'ai_macro_plan',
                testName: 'Kamp Programı İlerlemesi',
                answers: macroPlan.answers, 
                progressData: interactiveMacro, 
                status: 'pending'
            });
        }

        setHasChanges(false); 
        alert("Harika! İlerlemelerin başarıyla öğretmeninle paylaşıldı. ✅"); 
    } catch (error) {
        console.error("Kaydetme hatası:", error);
        alert("Sisteme kaydedilirken bir hata oluştu.");
    } finally {
        setLoading(false); 
    }
  };

 // 🚀 ZIRH: hedefSoru gibi sayısal verilerin map fonksiyonunu çökertmesini engelliyoruz
  const VALID_DAYS = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];
  const days = Object.keys(weekData).filter(key => VALID_DAYS.includes(key)); 
  
  let totalTasks = 0; let completedTasks = 0;
  Object.values(weekData).forEach(dayList => { if (Array.isArray(dayList)) { totalTasks += dayList.length; completedTasks += dayList.filter(t => t.completed).length; } }); 
  const progress = totalTasks > 0 ? Math.round((completedTasks/totalTasks)*100) : 0; 


const smartSourceSchedule =
  Array.isArray(
    smartPlan
      ?.answers
      ?.schedule
  )
    ? smartPlan.answers.schedule
    : [];


const smartSchedule =
  interactiveSmartSchedule.length > 0
    ? interactiveSmartSchedule
    : smartSourceSchedule;


const currentSmartWeek =
  smartSchedule[
    smartWeekIndex
  ] ||
  null;


const smartStrategyLabel =
  SMART_PLAN_STRATEGIES[
    smartPlan
      ?.answers
      ?.strategyId
  ]?.label ||
  'Akıllı Plan';


const smartDailyMinutes =
  Number(
    smartPlan
      ?.answers
      ?.dailyMinutes ||
    0
  );

// ============================================================
// AKILLI PLAN — ÖĞRENCİ İNTERAKTİF CHECKBOX STATE
// ============================================================

useEffect(() => {

  const sourceSchedule =
    Array.isArray(
      smartPlan
        ?.answers
        ?.schedule
    )
      ? smartPlan.answers.schedule
      : [];


  if (
    sourceSchedule.length === 0
  ) {

    setInteractiveSmartSchedule(
      []
    );

    return;
  }


  const interactiveSchedule =
    sourceSchedule.map(
      week => ({

        ...week,

        days:
          Array.isArray(
            week?.days
          )
            ? week.days.map(
                day => ({

                  ...day,

                  tasks:
                    Array.isArray(
                      day?.tasks
                    )
                      ? day.tasks.map(
                          task => ({

                            ...task,

                            completed:
                              Boolean(
                                task?.completed
                              )

                          })
                        )
                      : []

                })
              )
            : []

      })
    );


  setInteractiveSmartSchedule(
    interactiveSchedule
  );

}, [smartPlan]);



const toggleSmartTask = (
  weekIndex,
  dayIndex,
  taskIndex
) => {

  setInteractiveSmartSchedule(
    previousSchedule =>
      previousSchedule.map(
        (week, currentWeekIndex) => {

          if (
            currentWeekIndex !==
            weekIndex
          ) {
            return week;
          }


          return {

            ...week,

            days:
              (
                Array.isArray(
                  week?.days
                )
                  ? week.days
                  : []
              ).map(
                (
                  day,
                  currentDayIndex
                ) => {

                  if (
                    currentDayIndex !==
                    dayIndex
                  ) {
                    return day;
                  }


                  return {

                    ...day,

                    tasks:
                      (
                        Array.isArray(
                          day?.tasks
                        )
                          ? day.tasks
                          : []
                      ).map(
                        (
                          task,
                          currentTaskIndex
                        ) => {

                          if (
                            currentTaskIndex !==
                            taskIndex
                          ) {
                            return task;
                          }


                          return {

                            ...task,

                            completed:
                              !Boolean(
                                task?.completed
                              )

                          };
                        }
                      )

                  };
                }
              )

          };
            }
      )
  );

  setSmartHasChanges(
    true
  );
};

// ============================================================
// AKILLI PLAN — İLERLEME KAYIT MOTORU
// ============================================================

const handleSmartSubmit =
  async () => {

    if (
      !smartPlan ||
      interactiveSmartSchedule.length === 0 ||
      !smartHasChanges
    ) {
      return;
    }


    // Güvenlik:
    // Mevcut Akıllı Planın Firestore belge kimliği yoksa
    // yanlışlıkla yeni/kopya bir plan oluşturmayalım.
    if (!smartPlan?.firebaseId) {

      alert(
        '⚠️ Akıllı Plan kayıt kimliği alınamadı. Sayfayı yenileyip tekrar deneyiniz.'
      );

      return;
    }


    setLoading(true);


    try {

      const safeCode =
        user.clinicianCode ||
        user.refCode ||
        user.code ||
        "7335";

      const safeUid =
        user.clinicianUid ||
        user.uid ||
        "";

      const safeClass =
        user.class ||
        user.studentClass ||
        "Sınıfsız";

      const safeNo =
        user.no ||
        user.studentNo ||
        "0";

      const safeName =
        user.fullName ||
        user.name ||
        safeNo;


      const progressUpdatedAt =
        Date.now();


      const saveSuccess =
        await onSubmit({

          // Orijinal atanmış planın bütün üst verilerini koru.
          ...smartPlan,

          // En kritik alan:
          // yeni belge değil, mevcut Firestore belgesi güncellensin.
          firebaseId:
            smartPlan.firebaseId,

          id:
            smartPlan.id ||
            smartPlan.firebaseId,

          // Atama tarihini ilerleme tarihiyle ASLA ezme.
          createdAt:
            smartPlan.createdAt ||
            progressUpdatedAt,

          studentClass:
            smartPlan.studentClass ||
            safeClass,

          studentNo:
            smartPlan.studentNo ||
            safeNo,

          studentName:
            smartPlan.studentName ||
            safeName,

          clinicianCode:
            smartPlan.clinicianCode ||
            safeCode,

          clinicianUid:
            smartPlan.clinicianUid ||
            safeUid,

          testId:
            'smart_plan',

          testName:
            smartPlan.testName ||
            'Akıllı Çalışma Planı',

          answers: {
            ...(
              smartPlan?.answers ||
              {}
            ),

            schedule:
              interactiveSmartSchedule
          },

          progressData:
            interactiveSmartSchedule,

          // İlerleme zamanı ayrı tutulur.
          progressUpdatedAt,

          // Atanmış plan statüsünü bozma.
          status:
            smartPlan.status ||
            'assigned'
        });


      // onSubmit açıkça false döndürürse
      // kullanıcıya yanlış başarı mesajı göstermeyelim.
      if (saveSuccess === false) {
        throw new Error(
          'Akıllı Plan ilerlemesi veri tabanına kaydedilemedi.'
        );
      }


      // Yerel smartPlan state'ini de kaydedilen
      // yeni schedule ile senkron tut.
      setSmartPlan(
        previousPlan => ({

          ...previousPlan,

          answers: {
            ...(
              previousPlan?.answers ||
              {}
            ),

            schedule:
              interactiveSmartSchedule
          },

          progressData:
            interactiveSmartSchedule,

          progressUpdatedAt
        })
      );


      setSmartHasChanges(
        false
      );


      alert(
        '✅ Akıllı Plan ilerlemen kaydedildi ve rehber öğretmeninle paylaşıldı.'
      );

    } catch (error) {

      console.error(
        'Akıllı Plan ilerleme kayıt hatası:',
        error
      );

      alert(
        '⚠️ Akıllı Plan ilerlemesi kaydedilirken bir hata oluştu.'
      );

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {
    if (macroPlan && macroPlan.answers?.planText) {
      const text = macroPlan.answers.planText;
      const weeks = text.split(/(?=# )/).filter(Boolean);
      
      const parsed = weeks.map((weekText, wIdx) => {
        const lines = weekText.split('\n').filter(l => l.trim() !== '');
        const weekTitle = lines[0].replace('# ', '').trim();
        const days = [];
        let currentDay = null;

        lines.slice(1).forEach(line => {
          if (line.startsWith('**') || line.startsWith('* ')) {
            if (currentDay) days.push(currentDay);
            currentDay = { name: line.replace(/\*\*/g, '').replace('* ', '').replace(':', '').trim(), tasks: [] };
          } else if (line.startsWith('- ') && currentDay) {
            currentDay.tasks.push({
              id: `m-w${wIdx}-d${days.length}-t${currentDay.tasks.length}`,
              text: line.replace('- ', '').trim(),
              completed: false // Varsayılan olarak yapılmadı
            });
          }
        });
        if (currentDay) days.push(currentDay);
        return { title: weekTitle, days: days };
      });
      
      // Eğer veritabanında önceden kaydedilmiş ilerleme varsa onu kullan, yoksa sıfırdan oluştur
      setInteractiveMacro(macroPlan.progressData || parsed);
    }
  }, [macroPlan]);

  // 🖱️ YENİ: Makro Plan Görevlerini İşaretleme Motoru
  const toggleMacroTask = (wIdx, dIdx, tIdx) => {
    const newMacro = [...interactiveMacro];
    newMacro[wIdx].days[dIdx].tasks[tIdx].completed = !newMacro[wIdx].days[dIdx].tasks[tIdx].completed;
    setInteractiveMacro(newMacro);
    setHasChanges(true); // Görev işaretlendiğinde butonu mavi (kaydet) yap
  };

  return (
    <div className="space-y-8 no-print">
      
      {/* 🚀 YENİ: ÜST SEKME MENÜSÜ */}
      <div className="flex bg-slate-100 p-1.5 rounded-xl max-w-2xl mx-auto shadow-inner mb-8">
        <button 
          onClick={() => setActiveTab('plan')}
          className={`flex-1 py-2.5 px-4 text-sm font-bold rounded-lg transition-all duration-200 flex items-center justify-center gap-2 ${activeTab === 'plan' ? 'bg-white text-indigo-600 shadow-sm scale-105' : 'text-slate-500 hover:text-slate-700'}`}
        >
          <Calendar className="h-4 w-4"/> Planım
        </button>
        <button 
          onClick={() => setActiveTab('soru')}
          className={`flex-1 py-2.5 px-4 text-sm font-bold rounded-lg transition-all duration-200 flex items-center justify-center gap-2 ${activeTab === 'soru' ? 'bg-white text-blue-600 shadow-sm scale-105' : 'text-slate-500 hover:text-slate-700'}`}
        >
          <Edit3 className="h-4 w-4"/> Günlük Soru
        </button>
        <button 
          onClick={() => setActiveTab('deneme')}
          className={`flex-1 py-2.5 px-4 text-sm font-bold rounded-lg transition-all duration-200 flex items-center justify-center gap-2 ${activeTab === 'deneme' ? 'bg-white text-emerald-600 shadow-sm scale-105' : 'text-slate-500 hover:text-slate-700'}`}
        >
          <Target className="h-4 w-4"/> Deneme Yükle
        </button>
      </div>

      {/* --- TAB 1: PLAN GÖRÜNÜMÜ --- */}
      {activeTab === 'plan' && (
        <div className="space-y-8 animate-in fade-in duration-300">


{/* ====================================================== */}
{/* AKILLI PLAN ROBOTU — ÖĞRENCİ GÖRÜNÜMÜ */}
{/* ====================================================== */}

{smartSchedule.length > 0 &&
  currentSmartWeek && (

    <div className="mb-12 rounded-3xl overflow-hidden border border-indigo-200 bg-white shadow-lg">

      <div className="bg-gradient-to-r from-slate-950 via-indigo-950 to-slate-900 p-6 text-white">

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">

          <div>

            <p className="text-[10px] font-black uppercase tracking-[0.2em] text-indigo-300">
              Rehber360 Akıllı Plan Robotu
            </p>

            <h2 className="text-3xl font-black mt-1 flex items-center">
              <Brain className="h-7 w-7 mr-3 text-indigo-300" />
              Akıllı Planım
            </h2>

            <p className="text-sm text-slate-300 mt-2">
              Rehber öğretmenin tarafından senin çalışma düzenine göre oluşturulan plan.
            </p>

          </div>


          <div className="flex flex-wrap gap-2">

            <span className="px-3 py-2 rounded-xl bg-white/10 text-xs font-black">
              {smartPlan?.answers?.examMode || '-'}
            </span>

            <span className="px-3 py-2 rounded-xl bg-white/10 text-xs font-black">
              {smartStrategyLabel}
            </span>

            <span className="px-3 py-2 rounded-xl bg-white/10 text-xs font-black">
  {smartDailyMinutes} dk / gün
</span>


<button
  type="button"
  onClick={
    handleSmartSubmit
  }
  disabled={
    loading ||
    !smartHasChanges
  }
  className={`px-3 py-2 rounded-xl text-xs font-black flex items-center gap-2 transition ${
    smartHasChanges
      ? 'bg-emerald-500 text-white hover:bg-emerald-400'
      : 'bg-white/10 text-slate-400 cursor-not-allowed'
  }`}
>

  {
    loading
      ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        )
      : (
          <Save className="h-4 w-4" />
        )
  }

  {
    loading
      ? 'Kaydediliyor...'
      : (
          smartHasChanges
            ? 'İlerlemeyi Kaydet'
            : 'Güncel'
        )
  }

</button>

</div>

        </div>

      </div>


      <div className="p-5 md:p-6 bg-slate-50">

        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">

          <div className="bg-slate-900 p-4 flex items-center justify-between gap-3">

            <button
              type="button"
              onClick={() =>
                setSmartWeekIndex(
                  Math.max(
                    0,
                    smartWeekIndex - 1
                  )
                )
              }
              disabled={
                smartWeekIndex === 0
              }
              className={`px-3 py-2 rounded-xl text-xs font-black transition ${
                smartWeekIndex === 0
                  ? 'bg-slate-800 text-slate-600 cursor-not-allowed'
                  : 'bg-indigo-600 text-white hover:bg-indigo-500'
              }`}
            >
              ← Önceki Hafta
            </button>


            <div className="text-center">

              <p className="text-white text-lg font-black">
                {currentSmartWeek.weekNumber}. Hafta
              </p>

              <p className="text-[10px] text-slate-400 font-bold mt-1">
                {smartWeekIndex + 1} / {smartSchedule.length}
              </p>

            </div>


            <button
              type="button"
              onClick={() =>
                setSmartWeekIndex(
                  Math.min(
                    smartSchedule.length - 1,
                    smartWeekIndex + 1
                  )
                )
              }
              disabled={
                smartWeekIndex ===
                smartSchedule.length - 1
              }
              className={`px-3 py-2 rounded-xl text-xs font-black transition ${
                smartWeekIndex ===
                smartSchedule.length - 1
                  ? 'bg-slate-800 text-slate-600 cursor-not-allowed'
                  : 'bg-indigo-600 text-white hover:bg-indigo-500'
              }`}
            >
              Sonraki Hafta →
            </button>

          </div>


          <div className="p-5 grid md:grid-cols-2 xl:grid-cols-3 gap-4">

            {(currentSmartWeek.days || []).map(
              (day, dayIndex) => (

                <div
                  key={`${currentSmartWeek.weekNumber}-${day.day}-${dayIndex}`}
                  className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm"
                >

                  <div className="flex items-start justify-between gap-3 pb-3 mb-3 border-b border-slate-100">

                    <div>

                      <h3 className="font-black text-slate-800">
                        {day.day}
                      </h3>

                      <p className="text-[10px] font-bold text-slate-400 mt-1">
                        {day.taskCount || 0} görev
                      </p>

                    </div>


                    <span className="px-2.5 py-1 rounded-full bg-slate-100 text-slate-600 text-[10px] font-black">
                      {day.totalMinutes || 0}
                      {' / '}
                      {smartDailyMinutes}
                      {' dk'}
                    </span>

                  </div>


                  <div className="space-y-3">

                    {(day.tasks || []).map(
                      (task, taskIndex) => (

                        <div
  key={`${dayIndex}-${taskIndex}`}

  onClick={() =>
    toggleSmartTask(
      smartWeekIndex,
      dayIndex,
      taskIndex
    )
  }

  className={`rounded-xl border p-3 cursor-pointer transition-all ${
    task?.completed
      ? 'border-emerald-200 bg-emerald-50/70 opacity-70'
      : 'border-indigo-100 bg-indigo-50/50 hover:border-indigo-300 hover:bg-indigo-50'
  }`}
>

  <div className="flex items-center justify-between gap-2">

    <div className="flex items-center gap-2 min-w-0">

      <span
        className={`h-5 w-5 rounded-md border-2 flex items-center justify-center shrink-0 transition ${
          task?.completed
            ? 'bg-emerald-500 border-emerald-500'
            : 'bg-white border-indigo-300'
        }`}
      >

        {
          task?.completed && (
            <Check className="h-3 w-3 text-white" />
          )
        }

      </span>


      <span
        className={`text-[10px] font-black uppercase tracking-wide ${
          task?.completed
            ? 'text-emerald-700'
            : 'text-indigo-700'
        }`}
      >
        {
          SMART_TASK_LABELS[
            task.type
          ] ||
          task.type
        }
      </span>

    </div>


    <span className="text-[10px] font-black text-slate-500">
      {task.duration || 0} dk
    </span>

  </div>


                          {task.subject && (
                            <p className="text-xs font-black text-slate-800 mt-2">
                              {task.subject}
                            </p>
                          )}


                          {task.topic && (
                            <p className="text-[11px] font-bold text-slate-600 mt-1">
                              {task.topic}
                            </p>
                          )}


                          {SMART_TASK_DESCRIPTIONS[
                            task.type
                          ] && (

                            <p className="text-[10px] leading-relaxed text-slate-500 mt-2">
                              {
                                SMART_TASK_DESCRIPTIONS[
                                  task.type
                                ]
                              }
                            </p>

                          )}


                          {(task.questionCount ||
                            task.resource) && (

                            <p className="text-[10px] text-slate-500 mt-2">
                              {[
                                task.questionCount
                                  ? `${task.questionCount} soru`
                                  : '',
                                task.resource || ''
                              ]
                                .filter(Boolean)
                                .join(' • ')}
                            </p>

                          )}

                        </div>

                      )
                    )}

                  </div>

                </div>

              )
            )}

          </div>

        </div>

      </div>

    </div>

  )}
          
      {/* 1. SADECE MANUEL GÖREV VARSA ÜST PANELİ GÖSTER */}
      {totalTasks > 0 && (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h2 className="text-3xl font-black text-slate-800 flex items-center">
              <Check className="h-8 w-8 mr-3 text-blue-600"/> Özel Görevlerim
            </h2>
            <p className="text-slate-500 mt-1">Bu haftaya özel atanmış ek görevlerini tamamla ve durumunu bildir.</p>
          </div>
          <div className="flex items-center gap-4">
            <button onClick={handleManualSubmit} disabled={loading} className={`px-6 py-3 rounded-xl font-bold flex items-center transition shadow-lg ${hasChanges ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-blue-500/30' : 'bg-slate-100 text-slate-400'}`}>{loading ? <Loader2 className="h-5 w-5 animate-spin mr-2"/> : <Send className="h-5 w-5 mr-2"/>}{loading ? 'Gönderiliyor...' : (hasChanges ? 'Durumu Güncelle' : 'Güncel')}</button>
            <div className="flex items-center bg-white px-4 py-2 rounded-xl shadow-sm border border-slate-100">
              <div className="mr-3 text-right"><p className="text-xs font-bold text-slate-400 uppercase">İlerleme</p><p className="text-xl font-black text-green-600">%{progress}</p></div>
              <div className="h-10 w-10 relative"><svg className="h-full w-full" viewBox="0 0 36 36"><path className="text-slate-100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="4" /><path className="text-green-500" strokeDasharray={`${progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="currentColor" strokeWidth="4" /></svg></div>
            </div>
          </div>
        </div>
      )}

      {/* 2. HİÇBİR PLAN YOKSA UYARIYI GÖSTER */}
      {totalTasks === 0 &&
  !macroPlan &&
  smartSchedule.length === 0 && (
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-8 text-center text-blue-800">
          <Calendar className="h-12 w-12 mx-auto mb-4 opacity-50"/>
          <h3 className="font-bold text-lg">Henüz Bir Plan Atanmamış</h3>
          <p className="text-sm">Rehber öğretmenin senin için bir program oluşturduğunda burada göreceksin.</p>
        </div>
      )}

      {/* 3. MANUEL PLAN VARSA KUTULARI GÖSTER */}
      {totalTasks > 0 && (
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {days.map(day => (
            <div key={day} className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex flex-col h-full">
              <h3 className="font-bold text-slate-800 mb-3 flex items-center border-b pb-2"><Calendar className="h-4 w-4 mr-2 text-blue-500"/> {day}</h3>
              <div className="space-y-2 flex-1">
                {(!weekData[day] || weekData[day].length === 0) && <p className="text-xs text-slate-400 italic">Görev yok.</p>}
                {weekData[day]?.map(task => (
                  <div key={task.id} onClick={() => toggleTask(day, task.id)} className={`flex items-start p-2 rounded-lg cursor-pointer transition-all hover:bg-slate-50 ${task.completed ? 'opacity-50' : ''}`}>
                    <div className={`mt-0.5 h-5 w-5 rounded border-2 flex items-center justify-center mr-3 transition-colors shrink-0 ${task.completed ? 'bg-green-500 border-green-500' : 'border-slate-300'}`}>{task.completed && <Check className="h-3 w-3 text-white"/>}</div>
                    <span className={`text-sm ${task.completed ? 'line-through text-slate-400' : 'text-slate-700'}`}>{task.text}</span>
                  </div>
                ))}
              </div>
            </div>
         ))}
        </div>
      )}

      {/* 🚀 YENİ: İNTERAKTİF VE OYUNLAŞTIRILMIŞ MAKRO PLAN BÖLÜMÜ */}
      {interactiveMacro.length > 0 && (
        <div className="mt-16 pt-12 border-t-2 border-dashed border-slate-200 animate-in fade-in duration-500">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
            <div>
              <h2 className="text-3xl font-black text-slate-800 flex items-center">
                <Brain className="h-8 w-8 mr-3 text-indigo-600"/> Uzun Vadeli Kamp Programım
              </h2>
              <p className="text-slate-500 mt-2 font-medium">Rehber öğretmenin tarafından atanan rotada adım adım ilerle.</p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              {/* 🚀 YENİ: MAKRO PLAN İÇİN ÖZEL KAYDET BUTONU */}
              <button 
                onClick={handleManualSubmit} 
                disabled={loading || !hasChanges} 
                className={`px-5 py-2 rounded-xl font-bold flex items-center transition-all shadow-sm ${hasChanges ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-slate-100 text-slate-400'}`}
              >
                {loading ? <Loader2 className="h-5 w-5 animate-spin mr-2"/> : <Check className="h-5 w-5 mr-2"/>}
                {loading ? 'Kaydediliyor...' : (hasChanges ? 'İlerlemeyi Kaydet' : 'Güncel')}
              </button>

              <div className="bg-indigo-50 text-indigo-700 px-4 py-2 rounded-xl font-bold text-sm flex items-center border border-indigo-100 shadow-sm">
                <Sparkles className="h-4 w-4 mr-2"/> {interactiveMacro.length} Haftalık Plan
              </div>
            </div>
          </div>

          {/* HAFTA NAVİGASYONU (KONTROL PANELİ) */}
          <div className="bg-slate-900 p-4 rounded-t-3xl flex items-center justify-between border-b border-slate-700 shadow-lg">
            <button 
              onClick={() => setCurrentWeekIndex(Math.max(0, currentWeekIndex - 1))} 
              disabled={currentWeekIndex === 0}
              className={`px-4 py-2 rounded-xl font-bold transition-all ${currentWeekIndex === 0 ? 'opacity-30 cursor-not-allowed bg-slate-800 text-slate-500' : 'bg-indigo-600 text-white hover:bg-indigo-500'}`}
            >
              &larr; Önceki Hafta
            </button>
            
            <h3 className="text-xl font-black text-white text-center px-4 uppercase tracking-wider">
              {interactiveMacro[currentWeekIndex].title}
            </h3>
            
            <button 
              onClick={() => setCurrentWeekIndex(Math.min(interactiveMacro.length - 1, currentWeekIndex + 1))} 
              disabled={currentWeekIndex === interactiveMacro.length - 1}
              className={`px-4 py-2 rounded-xl font-bold transition-all ${currentWeekIndex === interactiveMacro.length - 1 ? 'opacity-30 cursor-not-allowed bg-slate-800 text-slate-500' : 'bg-indigo-600 text-white hover:bg-indigo-500'}`}
            >
              Sonraki Hafta &rarr;
            </button>
          </div>

          {/* TIKLANABİLİR GÖREV KUTULARI (GRID) */}
          <div className="bg-slate-800 p-6 rounded-b-3xl shadow-2xl grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {interactiveMacro[currentWeekIndex].days.map((day, dIdx) => (
              <div key={dIdx} className="bg-white p-5 rounded-2xl shadow-sm flex flex-col h-full border border-slate-200">
                <h4 className="font-bold text-slate-800 mb-4 pb-2 border-b border-slate-100 flex items-center uppercase text-sm tracking-wide">
                  <Calendar className="h-4 w-4 mr-2 text-indigo-500"/> {day.name}
                </h4>
                <div className="space-y-3 flex-1">
                  {day.tasks.map((task, tIdx) => (
                    <div 
                      key={task.id} 
                      onClick={() => toggleMacroTask(currentWeekIndex, dIdx, tIdx)} 
                      className={`flex items-start p-3 rounded-xl cursor-pointer transition-all border ${task.completed ? 'bg-emerald-50/50 border-emerald-100 opacity-60' : 'bg-slate-50 border-slate-100 hover:bg-indigo-50 hover:border-indigo-200'}`}
                    >
                      <div className={`mt-0.5 h-5 w-5 rounded border-2 flex items-center justify-center mr-3 shrink-0 transition-colors ${task.completed ? 'bg-emerald-500 border-emerald-500' : 'border-slate-300 bg-white'}`}>
                        {task.completed && <Check className="h-3 w-3 text-white"/>}
                      </div>
                      <span className={`text-xs font-medium leading-relaxed ${task.completed ? 'line-through text-slate-500' : 'text-slate-700'}`}>
                        {task.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
         </div>
        </div>
      )}
      
        </div>
      )} {/* TAB 1 BİTİŞİ */}

      {/* --- TAB 2: GÜNLÜK SORU GİRİŞİ --- */}
      {activeTab === 'soru' && (
        <div className="animate-in fade-in duration-300 max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-xl">
            <div className="bg-indigo-600 p-6 text-white">
              <h3 className="text-2xl font-black flex items-center"><Edit3 className="h-6 w-6 mr-3"/> Günlük Soru Girişi</h3>
              <p className="text-indigo-200 text-sm font-medium mt-2">Bugün hangi dersten kaç soru çözdüğünü kaydet ve hedefine yaklaş.</p>
            </div>
            
            <div className="p-6 md:p-8 bg-slate-50">
              {step === 1 ? (
                <div className="animate-in slide-in-from-right-4 duration-300">
                 <div className="flex bg-slate-200 p-1 rounded-xl w-full max-w-sm mx-auto mb-6 shadow-inner">
                    <button onClick={() => setSinavTuru('TYT')} className={`flex-1 py-2.5 text-sm font-black rounded-lg transition ${sinavTuru === 'TYT' ? 'bg-white text-indigo-700 shadow-sm scale-105' : 'text-slate-500 hover:text-slate-700'}`}>TYT</button>
                    <button onClick={() => setSinavTuru('AYT')} className={`flex-1 py-2.5 text-sm font-black rounded-lg transition ${sinavTuru === 'AYT' ? 'bg-white text-indigo-700 shadow-sm scale-105' : 'text-slate-500 hover:text-slate-700'}`}>AYT</button>
                    <button onClick={() => setSinavTuru('LGS')} className={`flex-1 py-2.5 text-sm font-black rounded-lg transition ${sinavTuru === 'LGS' ? 'bg-white text-indigo-700 shadow-sm scale-105' : 'text-slate-500 hover:text-slate-700'}`}>LGS</button>
                  </div>
                  <h4 className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-4 text-center">Hangi Dersten Soru Çözdün?</h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {Object.keys(mufredatVerisi).filter(k => k.startsWith(sinavTuru)).map(s => (
                      <button 
                        key={s} 
                        onClick={() => handleSubjectSelect(s)}
                        className="p-3 rounded-xl border-2 border-slate-200 bg-white hover:border-indigo-500 hover:bg-indigo-50 text-slate-700 font-bold text-sm transition flex items-center justify-center shadow-sm text-center"
                      >
                        {s.replace('TYT - ', '').replace('AYT - ', '').replace('LGS - ', '')}
                      </button>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="animate-in slide-in-from-right-4 duration-300 space-y-6">
                  <div className="flex items-center justify-between border-b border-slate-200 pb-4">
                    <button onClick={() => setStep(1)} className="text-indigo-600 font-bold text-sm flex items-center hover:bg-indigo-100 px-4 py-2 rounded-xl transition">
                      ← Branş Seçimine Dön
                    </button>
                    <span className="bg-indigo-100 text-indigo-800 px-5 py-2 rounded-xl font-black text-sm">{formData.ders}</span>
                  </div>
                  
                  <div>
                    <label className="text-xs font-bold text-slate-400 uppercase"><BookOpen className="h-3 w-3 inline mr-1"/>Çalışılan Konu</label>
                    <select 
                      value={formData.konu} 
                      onChange={e => setFormData({...formData, konu: e.target.value})} 
                      className="w-full mt-2 p-4 bg-white border border-slate-200 rounded-xl focus:ring-2 ring-indigo-500 outline-none font-bold text-slate-700 shadow-sm cursor-pointer"
                    >
                      <option value="" disabled>Konu Seçiniz...</option>
                      <option value="Genel Soru Çözümü">Genel Soru Çözümü / Deneme</option>
                      {formData.ders && mufredatVerisi[formData.ders] && mufredatVerisi[formData.ders].map(k => (
                        <option key={k} value={k}>{k}</option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-6">
                    <div>
                        <label className="text-xs font-bold text-slate-400 uppercase">Soru Sayısı</label>
                        <input type="number" value={formData.toplam} onChange={e => setFormData({...formData, toplam: e.target.value})} placeholder="0" className="w-full mt-2 p-4 bg-white border border-slate-200 rounded-xl focus:ring-2 ring-indigo-500 outline-none font-black text-2xl text-indigo-900 shadow-sm"/>
                    </div>
                    <div>
                        <label className="text-xs font-bold text-slate-400 uppercase">Süre (Dk)</label>
                        <input type="number" value={formData.sure} onChange={e => setFormData({...formData, sure: e.target.value})} placeholder="0" className="w-full mt-2 p-4 bg-white border border-slate-200 rounded-xl focus:ring-2 ring-indigo-500 outline-none font-black text-2xl text-indigo-900 shadow-sm"/>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4 bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
                    <div>
                        <label className="text-[11px] font-bold text-emerald-500 uppercase block text-center mb-2">Doğru</label>
                        <input type="number" value={formData.dogru} onChange={e => setFormData({...formData, dogru: e.target.value})} className="w-full p-3 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl outline-none font-black text-xl text-center"/>
                    </div>
                    <div>
                        <label className="text-[11px] font-bold text-red-500 uppercase block text-center mb-2">Yanlış</label>
                        <input type="number" value={formData.yanlis} onChange={e => setFormData({...formData, yanlis: e.target.value})} className="w-full p-3 bg-red-50 border border-red-200 text-red-700 rounded-xl outline-none font-black text-xl text-center"/>
                    </div>
                    <div>
                        <label className="text-[11px] font-bold text-slate-500 uppercase block text-center mb-2">Boş</label>
                        <input type="number" value={formData.bos} onChange={e => setFormData({...formData, bos: e.target.value})} className="w-full p-3 bg-slate-100 border border-slate-300 text-slate-700 rounded-xl outline-none font-black text-xl text-center"/>
                    </div>
                  </div>

                  <button onClick={handleSaveSoru} className="w-full mt-8 bg-indigo-600 hover:bg-indigo-700 text-white p-5 rounded-xl font-black text-lg flex items-center justify-center transition shadow-lg shadow-indigo-600/30">
                    <Save className="h-6 w-6 mr-2" /> İlerlemeyi Kaydet
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* --- TAB 3: DENEME SONUCU YÜKLE --- */}
      {activeTab === 'deneme' && (
        <div className="animate-in fade-in duration-300 max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-xl">
            <div className="bg-emerald-600 p-6 text-white">
              <h3 className="text-2xl font-black flex items-center"><Target className="h-6 w-6 mr-3"/> Deneme Sonucu Yükle</h3>
              <p className="text-emerald-100 text-sm font-medium mt-2">Girdiğin denemelerin netlerini girerek gelişim trendini uzmanınla paylaş.</p>
            </div>

            <div className="p-6 md:p-8 bg-slate-50">
              {denemeStep === 1 ? (
                <div className="animate-in slide-in-from-right-4 duration-300">
                  <h4 className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-6 text-center">Hangi Sınava Girdin?</h4>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <button onClick={() => handleDenemeSelect('TYT')} className="bg-white hover:bg-emerald-50 border-2 border-slate-200 hover:border-emerald-500 p-6 md:p-8 rounded-2xl flex flex-col items-center justify-center transition group shadow-sm">
                        <span className="text-3xl md:text-4xl font-black text-slate-800 group-hover:text-emerald-700">TYT</span>
                        <span className="text-xs md:text-sm text-slate-500 font-bold mt-2 md:mt-3">Temel Yeterlilik</span>
                    </button>
                    <button onClick={() => handleDenemeSelect('AYT')} className="bg-white hover:bg-blue-50 border-2 border-slate-200 hover:border-blue-500 p-6 md:p-8 rounded-2xl flex flex-col items-center justify-center transition group shadow-sm">
                        <span className="text-3xl md:text-4xl font-black text-slate-800 group-hover:text-blue-700">AYT</span>
                        <span className="text-xs md:text-sm text-slate-500 font-bold mt-2 md:mt-3">Alan Yeterlilik</span>
                    </button>
                    <button onClick={() => handleDenemeSelect('YDT')} className="bg-white hover:bg-purple-50 border-2 border-slate-200 hover:border-purple-500 p-6 md:p-8 rounded-2xl flex flex-col items-center justify-center transition group shadow-sm">
                        <span className="text-3xl md:text-4xl font-black text-slate-800 group-hover:text-purple-700">YDT</span>
                        <span className="text-xs md:text-sm text-slate-500 font-bold mt-2 md:mt-3">Yabancı Dil</span>
                    </button>
                    <button onClick={() => handleDenemeSelect('LGS')} className="bg-white hover:bg-amber-50 border-2 border-slate-200 hover:border-amber-500 p-6 md:p-8 rounded-2xl flex flex-col items-center justify-center transition group shadow-sm">
                        <span className="text-3xl md:text-4xl font-black text-slate-800 group-hover:text-amber-700">LGS</span>
                        <span className="text-xs md:text-sm text-slate-500 font-bold mt-2 md:mt-3">Lise Geçiş Sistemi</span>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="animate-in slide-in-from-right-4 duration-300 space-y-6">
                  <div className="flex items-center justify-between border-b border-slate-200 pb-4">
                    <button onClick={() => setDenemeStep(1)} className="text-emerald-600 font-bold text-sm flex items-center hover:bg-emerald-100 px-4 py-2 rounded-xl transition">
                      ← Sınav Seçimine Dön
                    </button>
                    <span className="bg-emerald-100 text-emerald-800 px-5 py-2 rounded-xl font-black text-sm">{denemeData.denemeTuru} Net Girişi</span>
                  </div>
                  
                  <div>
                    <label className="text-xs font-bold text-slate-400 uppercase"><BookOpen className="h-3 w-3 inline mr-1"/>Deneme Adı / Yayın</label>
                    <input type="text" value={denemeData.denemeAdi} onChange={e => setDenemeData({...denemeData, denemeAdi: e.target.value})} placeholder="Örn: 3D Yayınları Türkiye Geneli" className="w-full mt-2 p-4 bg-white border border-slate-200 rounded-xl focus:ring-2 ring-emerald-500 outline-none font-bold text-slate-700 shadow-sm"/>
                  </div>
                  
                  <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm space-y-4">
                    {denemeData.denemeTuru === 'TYT' && (
                      <>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24">Türkçe</span>
                            <input type="number" placeholder="Doğru" value={denemeData.turkceD} onChange={e => setDenemeData({...denemeData, turkceD: e.target.value})} className="flex-1 p-3 border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.turkceY} onChange={e => setDenemeData({...denemeData, turkceY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24">Matematik</span>
                            <input type="number" placeholder="Doğru" value={denemeData.matematikD} onChange={e => setDenemeData({...denemeData, matematikD: e.target.value})} className="flex-1 p-3 border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.matematikY} onChange={e => setDenemeData({...denemeData, matematikY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24">Sosyal</span>
                            <input type="number" placeholder="Doğru" value={denemeData.sosyalD} onChange={e => setDenemeData({...denemeData, sosyalD: e.target.value})} className="flex-1 p-3 border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.sosyalY} onChange={e => setDenemeData({...denemeData, sosyalY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24">Fen</span>
                            <input type="number" placeholder="Doğru" value={denemeData.fenD} onChange={e => setDenemeData({...denemeData, fenD: e.target.value})} className="flex-1 p-3 border border-emerald-200 bg-emerald-50 text-emerald-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.fenY} onChange={e => setDenemeData({...denemeData, fenY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                      </>
                    )}

                    {denemeData.denemeTuru === 'AYT' && (
                      <>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-sm">Matematik</span>
                            <input type="number" placeholder="Doğru" value={denemeData.matematikD} onChange={e => setDenemeData({...denemeData, matematikD: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.matematikY} onChange={e => setDenemeData({...denemeData, matematikY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-sm">Fen Bilimleri</span>
                            <input type="number" placeholder="Doğru" value={denemeData.fenD} onChange={e => setDenemeData({...denemeData, fenD: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.fenY} onChange={e => setDenemeData({...denemeData, fenY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-sm">Edebiyat</span>
                            <input type="number" placeholder="Doğru" value={denemeData.edebiyatD} onChange={e => setDenemeData({...denemeData, edebiyatD: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.edebiyatY} onChange={e => setDenemeData({...denemeData, edebiyatY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-sm">Tarih-1</span>
                            <input type="number" placeholder="Doğru" value={denemeData.tarih1D} onChange={e => setDenemeData({...denemeData, tarih1D: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.tarih1Y} onChange={e => setDenemeData({...denemeData, tarih1Y: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-sm">Coğrafya-1</span>
                            <input type="number" placeholder="Doğru" value={denemeData.cografya1D} onChange={e => setDenemeData({...denemeData, cografya1D: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.cografya1Y} onChange={e => setDenemeData({...denemeData, cografya1Y: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-[11px] leading-tight">Sosyal-2<br/>(Tar2,Coğ2)</span>
                            <input type="number" placeholder="Doğru" value={denemeData.tarih2D} onChange={e => setDenemeData({...denemeData, tarih2D: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.tarih2Y} onChange={e => setDenemeData({...denemeData, tarih2Y: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-28 text-sm">Felsefe & Din</span>
                            <input type="number" placeholder="Doğru" value={denemeData.felsefeD} onChange={e => setDenemeData({...denemeData, felsefeD: e.target.value})} className="flex-1 p-3 border border-blue-200 bg-blue-50 text-blue-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.felsefeY} onChange={e => setDenemeData({...denemeData, felsefeY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                      </>
                    )}

                    {denemeData.denemeTuru === 'YDT' && (
                      <div className="flex items-center gap-4">
                          <span className="font-bold text-slate-700 w-28 text-sm">Yabancı Dil</span>
                          <input type="number" placeholder="Doğru" value={denemeData.dilD} onChange={e => setDenemeData({...denemeData, dilD: e.target.value})} className="flex-1 p-3 border border-purple-200 bg-purple-50 text-purple-700 rounded-xl font-bold text-center outline-none"/>
                          <input type="number" placeholder="Yanlış" value={denemeData.dilY} onChange={e => setDenemeData({...denemeData, dilY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                      </div>
                    )}

                    {denemeData.denemeTuru === 'LGS' && (
                      <>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24 text-sm">Türkçe</span>
                            <input type="number" placeholder="Doğru" value={denemeData.lgsTurkceD} onChange={e => setDenemeData({...denemeData, lgsTurkceD: e.target.value})} className="flex-1 p-3 border border-amber-200 bg-amber-50 text-amber-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.lgsTurkceY} onChange={e => setDenemeData({...denemeData, lgsTurkceY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24 text-sm">Matematik</span>
                            <input type="number" placeholder="Doğru" value={denemeData.lgsMatD} onChange={e => setDenemeData({...denemeData, lgsMatD: e.target.value})} className="flex-1 p-3 border border-amber-200 bg-amber-50 text-amber-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.lgsMatY} onChange={e => setDenemeData({...denemeData, lgsMatY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24 text-sm">Fen Bil.</span>
                            <input type="number" placeholder="Doğru" value={denemeData.lgsFenD} onChange={e => setDenemeData({...denemeData, lgsFenD: e.target.value})} className="flex-1 p-3 border border-amber-200 bg-amber-50 text-amber-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.lgsFenY} onChange={e => setDenemeData({...denemeData, lgsFenY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24 text-sm">İnkılap Tar.</span>
                            <input type="number" placeholder="Doğru" value={denemeData.lgsInkilapD} onChange={e => setDenemeData({...denemeData, lgsInkilapD: e.target.value})} className="flex-1 p-3 border border-amber-200 bg-amber-50 text-amber-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.lgsInkilapY} onChange={e => setDenemeData({...denemeData, lgsInkilapY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24 text-sm">İngilizce</span>
                            <input type="number" placeholder="Doğru" value={denemeData.lgsIngD} onChange={e => setDenemeData({...denemeData, lgsIngD: e.target.value})} className="flex-1 p-3 border border-amber-200 bg-amber-50 text-amber-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.lgsIngY} onChange={e => setDenemeData({...denemeData, lgsIngY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="font-bold text-slate-700 w-24 text-sm">Din Kültürü</span>
                            <input type="number" placeholder="Doğru" value={denemeData.lgsDinD} onChange={e => setDenemeData({...denemeData, lgsDinD: e.target.value})} className="flex-1 p-3 border border-amber-200 bg-amber-50 text-amber-700 rounded-xl font-bold text-center outline-none"/>
                            <input type="number" placeholder="Yanlış" value={denemeData.lgsDinY} onChange={e => setDenemeData({...denemeData, lgsDinY: e.target.value})} className="flex-1 p-3 border border-red-200 bg-red-50 text-red-700 rounded-xl font-bold text-center outline-none"/>
                        </div>
                      </>
                    )}
                  </div>

                  <button onClick={handleDenemeSave} className="w-full mt-8 bg-emerald-600 hover:bg-emerald-700 text-white p-5 rounded-xl font-black text-lg flex items-center justify-center transition shadow-lg shadow-emerald-600/30">
                    <Save className="h-6 w-6 mr-2" /> Denemeyi Kaydet
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  ); 
};

export default StudentPlanner;